export const industriesData = [
    "Chiropractors",
    "Defense and Space Manufacturing",
    "Optometrists",
    "Computer Hardware Manufacturing",
    "Software Development",
    "Computer Networking Products",
    "Transportation Equipment Manufacturing",
    "Technology, Information and Internet",
    "Physical,Occupational and Speech Therapists",
    "Semiconductor Manufacturing",
    "Telecommunications",
    "Law Practice",
    "Housing Programs",
    "Legal Services",
    "Business Consulting and Services",
    "Biotechnology Research",
    "Family Planning Centers",
    "Medical Practices",
    "Transportation Programs",
    "Hospitals and Health Care",
    "Utilities Administration",
    "Pharmaceutical Manufacturing",
    "Outpatient Care Centers",
    "Veterinary Services",
    "Medical Equipment Manufacturing",
    "Space Research and Technology",
    "Motor Vehicle Parts Manufacturing",
    "Personal Care Product Manufacturing",
    "Retail Apparel and Fashion",
    "Sporting Goods Manufacturing",
    "Tobacco Manufacturing",
    "Medical and Diagnostic Laboratories",
    "Retail Groceries",
    "Food and Beverage Manufacturing",
    "Oil Extraction",
    "Computers and Electronics Manufacturing",
    "Natural Gas Extraction",
    "Manufacturing",
    "Furniture and Home Furnishings Manufacturing",
    "Home Health Care Services",
    "Retail",
    "Embedded Software Products",
    "Entertainment Providers",
    "Mobile Computing Software Products",
    "Gambling Facilities and Casinos",
    "Ambulance Services",
    "Desktop Computing Software Products",
    "IT System Custom Software Development",
    "Travel Arrangements",
    "IT System Operations and Maintenance",
    "Hospitality",
    "IT System Installation and Disposal",
    "Restaurants",
    "IT System Training and Support",
    "Hospitals",
    "Spectator Sports",
    "IT System Data Services",
    "Food and Beverage Services",
    "IT System Testing and Evaluation",
    "Movies, Videos, and Sound",
    "Broadcast Media Production and Distribution",
    "Museums, Historical Sites, and Zoos",
    "Artists and Writers",
    "Performing Arts",
    "Recreational Facilities",
    "Banking",
    "Insurance",
    "Nursing Homes and Residential Care Facilities",
    "Financial Services",
    "Real Estate",
    "Investment Banking",
    "Investment Management",
    "Accounting",
    "Construction",
    "Wholesale Building Materials",
    "Architecture and Planning",
    "Civil Engineering",
    "Internet News",
    "viation and Aerospace Component Manufacturing",
    "Blogs",
    "Motor Vehicle Manufacturing",
    "Interior Design",
    "Chemical Manufacturing",
    "Social Networking Platforms",
    "Machinery Manufacturing",
    "Household and Institutional Furniture Manufacturing",
    "Business Intelligence Platforms",
    "Mining",
    "Business Content",
    "Oil and Gas",
    "Data Security Software Products",
    "Shipbuilding",
    "Utilities",
    "Mobile Gaming Apps",
    "Textile Manufacturing",
    "Internet Publishing",
    "Paper and Forest Product Manufacturing",
    "Media and Telecommunications",
    "Railroad Equipment Manufacturing",
    "Blockchain Services",
    "Farming",
    "Services for the Elderly and Disabled",
    "Ranching",
    "Dairy Product Manufacturing",
    "Office Furniture and Fixtures Manufacturing",
    "Fisheries",
    "Community Services",
    "Primary and Secondary Education",
    "Higher Education",
    "Education Administration Programs",
    "Research Services",
    "Mattress and Blinds Manufacturing",
    "Armed Forces",
    "Legislative Offices",
    "Administration of Justice",
    "International Affairs",
    "Emergency and Relief Services",
    "Government Administration",
    "Executive Offices",
    "Law Enforcement",
    "Vocational Rehabilitation Services",
    "Public Safety",
    "Public Policy Offices",
    "Advertising Services",
    "Child Day Care Services",
    "Newspaper Publishing",
    "Performing Arts and Spectator Sports",
    "Book and Periodical Publishing",
    "Printing Services",
    "Information Services",
    "Libraries",
    "Theater Companies",
    "Environmental Services",
    "Freight and Package Transportation",
    "Dance Companies",
    "Individual and Family Services",
    "Religious Institutions",
    "Civic and Social Organizations",
    "Consumer Services",
    "Circuses and Magic Shows",
    "Truck Transportation",
    "Warehousing and Storage",
    "Sports Teams and Clubs",
    "Airlines and Aviation",
    "Maritime Transportation",
    "Racetracks",
    "IT Services and IT Consulting",
    "Market Research",
    "Public Relations and Communications Services",
    "Design Services",
    "Non-profit Organizations",
    "Fundraising",
    "Strategic Management Services",
    "Writing and Editing",
    "Staffing and Recruiting",
    "Wholesale Motor Vehicles and Parts",
    "Professional Training and Coaching",
    "Venture Capital and Private Equity Principals",
    "Political Organizations",
    "Translation and Localization",
    "Computer Games",
    "Events Services",
    "Retail Art Supplies",
    "Museums",
    "Appliances, Electrical, and Electronics Manufacturing",
    "Online Audio and Video Media",
    "Wholesale Furniture and Home Furnishings",
    "Historical Sites",
    "Nanotechnology Research",
    "Retail Art Dealers",
    "Musicians",
    "Zoos and Botanical Gardens",
    "Transportation, Logistics, Supply Chain and Storage",
    "Plastics Manufacturing",
    "Computer and Network Security",
    "Wireless Services",
    "Amusement Parks and Arcades",
    "Alternative Dispute Resolution",
    "Security and Investigations",
    "Facilities Services",
    "Outsourcing and Offshoring Consulting",
    "Wellness and Fitness Services",
    "Alternative Medicine",
    "Media Production",
    "Animation and Post-production",
    "Leasing Non-residential Real Estate",
    "Capital Markets",
    "Wholesale Photography Equipment and Supplies",
    "Think Tanks",
    "Philanthropic Fundraising Services",
    "Golf Courses and Country Clubs",
    "E-Learning Providers",
    "Wholesale",
    "Wholesale Computer Equipment",
    "Skiing Facilities",
    "Wholesale Import and Export",
    "Industrial Machinery Manufacturing",
    "Photography",
    "Human Resources Services",
    "Retail Office Equipment",
    "Mental Health Care",
    "Graphic Design",
    "International Trade and Development",
    "Beverage Manufacturing",
    "Accommodation and Food Services",
    "Wholesale Metals and Minerals",
    "Retail Luxury Goods and Jewelry",
    "Glass, Ceramics and Concrete Manufacturing",
    "Packaging and Containers Manufacturing",
    "Hotels and Motels",
    "Automation Machinery Manufacturing",
    "Wholesale Appliances, Electrical, and Electronics",
    "Government Relations Services",
    "Bed-and-Breakfasts, Hostels, Homestays",
    "Horticulture",
    "Wholesale Hardware, Plumbing, Heating Equipment",
    "Wholesale Machinery",
    "Caterers",
    "Mobile Food Services",
    "Renewable Energy Power Generation",
    "Bars, Taverns, and Nightclubs",
    "Renewable Energy Equipment Manufacturing",
    "Engineering Services",
    "Services for Renewable Energy",
    "Digital Accessibility Services",
    "Accessible Hardware Manufacturing",
    "Accessible Architecture and Design",
    "Robot Manufacturing",
    "Robotics Engineering",
    "Repair and Maintenance",
    "Surveying and Mapping Services",
    "Vehicle Repair and Maintenance",
    "Retail Pharmacies",
    "Climate Technology Product Manufacturing",
    "Climate Data and Analytics",
    "Alternative Fuel Vehicle Manufacturing",
    "Wholesale Recyclable Materials",
    "Smart Meter Manufacturing",
    "Fuel Cell Manufacturing",
    "Wholesale Luxury Goods and Jewelry",
    "Regenerative Design",
    "Wholesale Paper Products",
    "Electronic and Precision Equipment Maintenance",
    "Wholesale Drugs and Sundries",
    "Wholesale Apparel and Sewing Supplies",
    "Commercial and Industrial Machinery Maintenance",
    "Farming, Ranching, Forestry",
    "Reupholstery and Furniture Repair",
    "Wholesale Footwear",
    "Wholesale Food and Beverage",
    "Footwear and Leather Goods Repair",
    "Personal and Laundry Services",
    "Personal Care Services",
    "Laundry and Drycleaning Services",
    "Wholesale Raw Farm Products",
    "Wholesale Chemical and Allied Products",
    "Pet Services",
    "Wholesale Petroleum and Petroleum Products",
    "Wholesale Alcoholic Beverages",
    "Ranching and Fisheries",
    "Internet Marketplace Platforms",
    "Retail Motor Vehicles",
    "Household Services",
    "Retail Furniture and Home Furnishings",
    "Retail Appliances, Electrical, and Electronic Equipment",
    "Forestry and Logging",
    "Retail Building Materials and Garden Equipment",
    "Health and Human Services",
    "Public Health",
    "Public Assistance Programs",
    "Food and Beverage Retail",
    "Air, Water, and Waste Program Management",
    "Conservation Programs",
    "Housing and Community Development",
    "Community Development and Urban Planning",
    "Economic Programs",
    "Oil, Gas, and Mining",
    "Retail Health and Personal Care Products",
    "Coal Mining",
    "Military and International Affairs",
    "Metal Ore Mining",
    "Retail Gasoline",
    "Operations Consulting",
    "Nonmetallic Mineral Mining",
    "Electric Power Transmission, Control, and Distribution",
    "Retail Musical Instruments",
    "Electric Power Generation",
    "Hydroelectric Power Generation",
    "Retail Books and Printed News",
    "Fossil Fuel Electric Power Generation",
    "Nuclear Electric Power Generation",
    "Solar Electric Power Generation",
    "Environmental Quality Programs",
    "Geothermal Electric Power Generation",
    "Biomass Electric Power Generation",
    "Natural Gas Distribution",
    "Water, Waste, Steam, and Air Conditioning Services",
    "Retail Florists",
    "Retail Office Supplies and Gifts",
    "Water Supply and Irrigation Systems",
    "Steam and Air-Conditioning Supply",
    "Building Construction",
    "Retail Recyclable Materials & Used Merchandise",
    "Residential Building Construction",
    "Data Infrastructure and Analytics",
    "Nonresidential Building Construction",
    "Utility System Construction",
    "Electrical Equipment Manufacturing",
    "Online and Mail Order Retail",
    "Subdivision of Land",
    "Highway, Street, and Bridge Construction",
    "Specialty Trade Contractors",
    "Building Structure and Exterior Contractors",
    "Wind Electric Power Generation",
    "Wineries",
    "Building Equipment Contractors",
    "Rail Transportation",
    "Building Finishing Contractors",
    "Ground Passenger Transportation",
    "Urban Transit Services",
    "Interurban and Rural Bus Services",
    "Taxi and Limousine Services",
    "Animal Feed Manufacturing",
    "School and Employee Bus Services",
    "Shuttles and Special Needs Transportation Services",
    "Sugar and Confectionery Product Manufacturing",
    "Pipeline Transportation",
    "Fruit and Vegetable Preserves Manufacturing",
    "Sightseeing Transportation",
    "Meat Products Manufacturing",
    "Seafood Product Manufacturing",
    "Baked Goods Manufacturing",
    "Postal Services",
    "Breweries",
    "Distilleries",
    "Technology, Information and Media",
    "Periodical Publishing",
    "Book Publishing",
    "Movies and Sound Recording",
    "Apparel Manufacturing",
    "Sound Recording",
    "Sheet Music Publishing",
    "Radio and Television Broadcasting",
    "Fashion Accessories Manufacturing",
    "Leather Product Manufacturing",
    "Cable and Satellite Programming",
    "Telecommunications Carriers",
    "Footwear Manufacturing",
    "Satellite Telecommunications",
    "Women's Handbag Manufacturing",
    "Credit Intermediation",
    "Savings Institutions",
    "Loan Brokers",
    "Oil and Coal Product Manufacturing",
    "Securities and Commodity Exchanges",
    "Chemical Raw Materials Manufacturing",
    "Investment Advice",
    "Insurance Carriers",
    "Artificial Rubber and Synthetic Fiber Manufacturing",
    "Agricultural Chemical Manufacturing",
    "Insurance Agencies and Brokerages",
    "Claims Adjusting, Actuarial Services",
    "Funds and Trusts",
    "Insurance and Employee Benefit Funds",
    "Pension Funds",
    "Paint, Coating, and Adhesive Manufacturing",
    "Trusts and Estates",
    "Soap and Cleaning Product Manufacturing",
    "Real Estate and Equipment Rental Services",
    "Leasing Residential Real Estate",
    "Plastics and Rubber Product Manufacturing",
    "Real Estate Agents and Brokers",
    "Equipment Rental Services",
    "Consumer Goods Rental",
    "Rubber Products Manufacturing",
    "Clay and Refractory Products Manufacturing",
    "Commercial and Industrial Equipment Rental",
    "Glass Product Manufacturing",
    "Wood Product Manufacturing",
    "Professional Services",
    "Lime and Gypsum Products Manufacturing",
    "Abrasives and Nonmetallic Minerals Manufacturing",
    "Primary Metal Manufacturing",
    "IT System Design Services",
    "Marketing Services",
    "Fabricated Metal Products",
    "Cutlery and Handtool Manufacturing",
    "Architectural and Structural Metal Manufacturing",
    "Boilers, Tanks, and Shipping Container Manufacturing",
    "Construction Hardware Manufacturing",
    "Spring and Wire Product Manufacturing",
    "Turned Products and Fastener Manufacturing",
    "Holding Companies",
    "Metal Treatments",
    "Industry Associations",
    "Landscaping Services",
    "Professional Organizations",
    "Metal Valve, Ball, and Roller Manufacturing",
    "Administrative and Support Services",
    "Office Administration",
    "Executive Search Services",
    "Temporary Help Services",
    "Agriculture, Construction, Mining Machinery Manufacturing",
    "Telephone Call Centers",
    "Collection Agencies",
    "Commercial and Service Industry Machinery Manufacturing",
    "HVAC and Refrigeration Equipment Manufacturing",
    "Metalworking Machinery Manufacturing",
    "Security Guards and Patrol Services",
    "Security Systems Services",
    "Engines and Power Transmission Equipment Manufacturing",
    "Janitorial Services",
    "Waste Collection",
    "Waste Treatment and Disposal",
    "Communications Equipment Manufacturing",
    "Audio and Video Equipment Manufacturing",
    "Education",
    "Measuring and Control Instrument Manufacturing",
    "Secretarial Schools",
    "Technical and Vocational Training",
    "Magnetic and Optical Media Manufacturing",
    "Cosmetology and Barber Schools",
    "Flight Training",
    "Electric Lighting Equipment Manufacturing",
    "Fine Arts Schools",
    "Sports and Recreation Instruction",
    "Household Appliance Manufacturing",
    "Language Schools",
    "Physicians",
    "Courts of Law",
    "Correctional Institutions",
    "Dentists",
    "Fire Protection"
];